<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('confirmation-delete-mailing') }}</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ $t('question-delete-mailing') }} “{{ this.data.name }}”?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="close">{{ $t('cancel') }}</button>
          <button type="button" class="btn btn-primary" @click="deleteMailing">{{ $t('confirm') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.help-donate{
  display: block;
  text-align: center;
  margin-bottom: 3px;
  font-size: 11px;
  line-height: 135%;
  color: #FF0000;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
  position: relative;
}
.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}
.modal-footer {
  border-top: 1px solid #eeeeee;
}
.light-attention{
  display: inline-block;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  margin-top: 31px !important;
  margin-bottom: 5px !important;
}
.account__balance{
  background: rgba(233, 159, 84, 0.1);
  border: 1px dashed #E99F54;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 10px 0 10px 0;
  max-width: 430px;
  height: 203px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.account__balance .account__balance-header{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #484848;
}
.account__balance .account__balance-sum{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #484848;
}
</style>

<script>
import axios from "axios";

export default {
  name: 'question-delete-mailing',
  props: ['mailing'],
  data: function(){
    return{
      data: this.mailing
    }
  },
  watch: {
    mailing: function(val){
      if(val){
        this.data = val;
      }
    }
  },
  methods: {
    deleteMailing: function(){
      this.isLoading = true;
      var data = {
        mailing_id: this.data.id,
      }
      axios.post('deleteMailing', data).then(response => {
        var status = response.data.status;
        if (status) {
          this.$toast.success("Рассылка успешно удалена");
          this.$root.$emit('updateMailing');
          this.close();
        }
      });
    },
    close: function() {
      this.$emit('close');
    },
  },
};
</script>